import { EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { selectMany } from '@ngneat/elf-entities';
import { select } from '@ngneat/elf';
function withPagination(options) {
  var _options$initialPage;
  return {
    props: {
      pagination: {
        currentPage: (_options$initialPage = options == null ? void 0 : options.initialPage) != null ? _options$initialPage : 1,
        pages: {},
        perPage: 0,
        lastPage: 0,
        total: 0
      }
    },
    config: undefined
  };
}
function setPage(key, ids) {
  return function (state) {
    return Object.assign({}, state, {
      pagination: Object.assign({}, state.pagination, {
        pages: Object.assign({}, state.pagination.pages, {
          [key]: ids
        })
      })
    });
  };
}
function selectPaginationData() {
  return select(getPaginationData());
}
function getPaginationData() {
  return function (state) {
    return state.pagination;
  };
}
function updatePaginationData(data) {
  return function (state) {
    return Object.assign({}, state, {
      pagination: Object.assign({}, state.pagination, data)
    });
  };
}
function deletePage(id) {
  return function (state) {
    const pages = Object.assign({}, state.pagination.pages);
    Reflect.deleteProperty(pages, id);
    return Object.assign({}, state, {
      pagination: Object.assign({}, state.pagination, {
        pages
      })
    });
  };
}
function deleteAllPages() {
  return function (state) {
    return Object.assign({}, state, {
      pagination: Object.assign({}, state.pagination, {
        pages: {}
      })
    });
  };
}
function setCurrentPage(id) {
  return function (state) {
    return Object.assign({}, state, {
      pagination: Object.assign({}, state.pagination, {
        currentPage: id
      })
    });
  };
}
function selectCurrentPage() {
  return select(state => state.pagination.currentPage);
}
function selectHasPage(id) {
  return select(hasPage(id));
}
function hasPage(id) {
  return function (state) {
    return Reflect.has(state.pagination.pages, id);
  };
}
function selectCurrentPageEntities() {
  return function (source) {
    return source.pipe(selectCurrentPage()).pipe(switchMap(page => {
      return source.pipe(select(state => state.pagination.pages[page])).pipe(switchMap(ids => source.pipe(selectMany(ids != null ? ids : []))));
    }));
  };
}
function skipWhilePageExists(store, page, options) {
  return function (source) {
    if (store.query(hasPage(page))) {
      var _options$returnSource;
      return (_options$returnSource = options == null ? void 0 : options.returnSource) != null ? _options$returnSource : EMPTY;
    }
    return source;
  };
}
export { deleteAllPages, deletePage, getPaginationData, hasPage, selectCurrentPage, selectCurrentPageEntities, selectHasPage, selectPaginationData, setCurrentPage, setPage, skipWhilePageExists, updatePaginationData, withPagination };